import { render, staticRenderFns } from "./ChangeUsername.vue?vue&type=template&id=5f7184b8&scoped=true&"
import script from "./ChangeUsername.vue?vue&type=script&lang=js&"
export * from "./ChangeUsername.vue?vue&type=script&lang=js&"
import style0 from "./ChangeUsername.vue?vue&type=style&index=0&id=5f7184b8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7184b8",
  null
  
)

export default component.exports